export const permSales = [
    { name: "Automatic_Insert", label: "perm-automatic-entry", visible: true },
    { name: "ShowQtyScreen", label: "perm-hide-qty-screen", visible: false },
    {
        name: "UpdateSalePrice",
        label: "allow-edit-sale-price",
        visible: true,
    },
    {
        name: "sale_no_less_than_purch",
        label: "perm-block-sale-below-purchase",
        visible: true,
    },
    {
        name: "sale_no_less_than_minPrice",
        label: "perm-block-sale-below-minimum",
        visible: true,
    },
    {
        name: "UpdateSaleDate",
        label: "allow-edit-sale-invoice-date",
        visible: true,
    },
    {
        name: "SaleInMinus",
        label: "allow-sale-without-stock-quantity",
        visible: true,
    },
    {
        name: "saleVatUpdate",
        label: "allow-edit-tax-on-sale",
        visible: true,
    },
    {
        name: "allow_salePrice_zero",
        label: "perm-allow-zero-sale-gift",
        visible: true,
    },
    {
        name: "allow_return_Without_bill",
        label: "perm-allow-return-without-invoice",
        visible: true,
    },
    {
        name: "allow_replace_Without_bill",
        label: "allow-replace-without-invoice",
        visible: true,
    },
    {
        name: "inv_post_unlock",
        label: "perm-allow-edit-delete-posted-invoice",
        visible: false,
    },
    {
        // this field for users table
        name: "register_customer_no_account",
        label: "allow-customer-without-account",
        visible: true,
    },
    {
        name: "allow_discount",
        label: "allow-discount",
        visible: true
    },
    {
        name: "PrintAfter_Save",
        label: "print-invoice-after-save",
        visible: true,
    },
    {
        name: "Purch_out_goods",
        label: "print-goods-exit-permit",
        visible: true,
    },
    {
        name: "NoRepeatItem",
        label: "perm-cancel-item-grouping",
        visible: true,
    },
    {
        name: "use_barcode_reader",
        label: "use-barcode-reader",
        visible: true,
    },
    {
        name: "Cust_SalePrice",
        label: "perm-last-sale-price-per-customer",
        visible: true,
    },
    {
        name: "ShowBtnCar",
        label: "show-car-specifications",
        visible: true,
    },
    {
        name: "return_same_invoice_date",
        label: "perm-return-on-sale-date",
        visible: true,
    },
    {
        name: "hide_item_data",
        label: "perm-hide-add-item-button",
        visible: true,
    },
    {
        name: "hide_item_info",
        label: "perm-hide-item-info",
        visible: true,
    },
    {
        name: "Show_units",
        label: "perm-show-sub-units-in-sales",
        visible: true,
    },
    {
        name: "show_cust_balance",
        label: "perm-show-account-balance-on-print",
        visible: true,
    }, {
        name: "Show_Sum_Amt_Bill",
        label: "Hide Totals In Search Screen",
        visible: true,
    },
    // { name: "allow_discount", label: "allow-discount", visible: true },
];

export const permPurchase = [
    { name: "Automatic_Insert", label: "perm-automatic-entry", visible: true },
    {
        name: "UpdatePurchDate",
        label: "allow-edit-purchase-invoice-date",
        visible: true,
    },
    {
        name: "UpdatePurchPrice",
        label: "allow-edit-purchase-price",
        visible: true,
    },
    {
        name: "purchVatUpdate",
        label: "perm-allow-edit-tax-on-purchase",
        visible: true,
    },
    {
        name: "use_price_without_vat",
        label: "use-price-excluding-tax-purchase-invoice",
        visible: true,
    },
    {
        name: "Purch_than_Less_Purch_Item",
        label: "perm-allow-purchase-below-item-price",
        visible: true,
    },
    {
        name: "SaleInMinus",
        label: "allow-purchase-return-without-stock-quantity",
        visible: true,
    },
    {
        name: "Cust_PurchPrice",
        label: "perm-last-purchase-price-per-supplier",
        visible: false,
    },
    {
        name: "Hide_Purch_Bill_Price",
        label: "perm-hide-sale-price",
        visible: true,
    },
    {
        name: "Purch_out_goods",
        label: "print-goods-exit-permit-purchase-return",
        visible: true,
    },

    {
        name: "allow_discount",
        label: "allow-discount",
        visible: true
    },
    {
        name: "IS_Delete",
        label: "allow-delete-invoice-after-posting",
        visible: true,
    },
    {
        name: "IS_Update",
        label: "allow-edit-invoice-after-posting",
        visible: true,
    },
    {
        name: "NoRepeatItem",
        label: "perm-cancel-item-grouping",
        visible: true,
    },
    {
        name: "Cust_SalePrice",
        label: "perm-last-purchase-price-per-supplier",
        visible: true,
    },
    {
        name: "return_same_invoice_date",
        label: "perm-return-on-purchase-date",
        visible: true,
    },
    {
        name: "allow_return_Without_bill",
        label: "perm-allow-return-without-invoice",
        visible: true,
    },
    {
        name: "use_barcode_reader",
        label: "use-barcode-reader",
        visible: true,
    },
    {
        name: "show_cust_balance",
        label: "perm-show-account-balance-on-print",
        visible: true,
    },
];

export const permPos = [
    {
        name: "SalePointOnly",
        label: "enable-pos-screen-for-user",
        visible: true,
    },
    {
        name: "used_Nsale_screen",
        label: "use-sales-screen",
        visible: true,
    },
    {
        name: "used_Rsale_screen",
        label: "use-return-screen",
        visible: true,
    },
    {
        name: "used_switch_screen",
        label: "use-replace-screen",
        visible: false,
    },
    {
        name: "used_Items_screen",
        label: "use-item-entry-screen",
        visible: true,
    },
    {
        name: "used_Group_screen",
        label: "use-groups-screen",
        visible: true,
    },
    {
        name: "used_Bcode_screen",
        label: "perm-use-barcode-print",
        visible: false,
    },
    {
        name: "used_Jarde_screen",
        label: "use-item-inventory-screen",
        visible: true,
    },
    {
        name: "used_jrans_screen",
        label: "perm-use-detailed-item-movement",
        visible: true,
    },
    {
        name: "used_Dialy_screen",
        label: "perm-use-daily-movement-report",
        visible: true,
    },
    {
        name: "used_Point_screen",
        label: "reset-pos-statistics-display",
        visible: false,
    },
    {
        name: "used_Treas_screen",
        label: "use-cashbox-movement-report",
        visible: true,
    },
    {
        name: "used_Accnt_screen",
        label: "use-account-statement-screen",
        visible: true,
    },
    {
        name: "used_SSarf_screen",
        label: "use-payment-voucher-screen",
        visible: true,
    },
    {
        name: "used_itmove_screen",
        label: "use-item-movement-report-screen",
        visible: true,
    },
    {
        name: "used_Sqabd_screen",
        label: "use-receipt-voucher-screen",
        visible: true,
    },
    {
        name: "used_purch_screen",
        label: "use-purchases-screen",
        visible: true,
    },
    {
        name: "used_Rpurch_screen",
        label: "use-purchase-return-screen",
        visible: true,
    },
    {
        name: "notShowSales",
        label: "hide-sales-show-invoice-count",
        visible: true,
    },
    {
        name: "disable_customer",
        label: "perm-cash-customer-only",
        visible: true,
    },
    {
        name: "pos_dashboard_zero",
        label: "reset-pos-statistics-display",
        visible: true,
    },
    {
        name: "pos_dashboard_zero",
        label: "reset-pos-statistics-display",
        visible: true,
    },
    {
        name: "used_twreed_makhzni_screen",
        label: "use-stock-supply-screen",
        visible: true,
    },
    {
        name: "used_sarfe_mkhzni_screen",
        label: "use-stock-issue-screen",
        visible: true,
    },
    {
        name: "used_estlam_mkhzni_screen",
        label: "use-stock-receipt-screen",
        visible: true,
    },
    {
        name: "used_tasweay_mkhzni_screen",
        label: "use-stock-settlement-screen",
        visible: true,
    },
    { name: "", label: "allow-discount", visible: false },
];

export const permShifts = [
    {
        name: "used_shifts_trans",
        label: "perm-shifts-required",
        visible: true,
    },
    {
        name: "used_shifts_transOpen",
        label: "allow-open-shifts",
        visible: true,
    },
    {
        name: "used_shifts_transClose",
        label: "perm-allow-close-shifts",
        visible: true,
    },
    {
        name: "show_only_shiftcash",
        label: "perm-show-cash-received-on-close",
        visible: true,
    },

];

export const permBasic = [
    { name: "HidePurchPrice", label: "hide-purchase-price" },
    { name: "NoRepeatItem", label: "prevent-item-name-duplicate" },
    {
        name: "show_ItemExpired_Alert",
        label: "perm-hide-item-alerts-on-entry",
    },
    {
        name: "update_price_first_stock",
        label: "perm-update-prices-on-opening-stock",
    },
    {
        name: "update_price_pursh_bill",
        label: "perm-update-prices-on-purchase-invoice",
    },
    {
        name: "update_price_currencies",
        label: "perm-update-sale-price-on-sales-invoice",
    },
    {
        name: "is_saleprice_less_purch",
        label: "perm-block-sale-price-below-purchase",
    },
    {
        name: "show_unit_on_bills",
        label: "perm-show-sub-units-on-invoices",
    },
    { name: "costWithVat", label: "price-includes-tax" },
    {
        name: "show_price_on_bills",
        label: "perm-show-item-prices-on-invoices",
    },
    { name: "usePriceBeforVat", label: "use-price-before-tax" },
    { name: "hide_item_balance", label: "perm-hide-item-balance" },
    {
        name: "disable_type_sale_price",
        label: "perm-disable-price-levels",
    },
];

export const permQutions = [
    { name: "Automatic_Insert", label: "perm-automatic-entry", visible: true },
    { name: "ShowQtyScreen", label: "perm-hide-qty-screen", visible: false },
    {
        name: "UpdateSalePrice",
        label: "allow-edit-quotation-price",
        visible: true,
    },
    {
        name: "sale_no_less_than_purch",
        label: "perm-block-sale-below-purchase",
        visible: true,
    },
    {
        name: "sale_no_less_than_minPrice",
        label: "perm-block-sale-below-minimum",
        visible: true,
    },
    {
        name: "UpdateSaleDate",
        label: "allow-edit-quotation-date",
        visible: true,
    },
    {
        name: "SaleInMinus",
        label: "allow-quotation-without-stock-quantity",
        visible: true,
    },
    {
        name: "saleVatUpdate",
        label: "allow-edit-quotation-tax",
        visible: true,
    },
    {
        name: "allow_salePrice_zero",
        label: "allow-zero-sale-price",
        visible: true,
    },
    {
        name: "allow_return_Without_bill",
        label: "perm-allow-return-without-invoice",
        visible: false,
    },
    {
        name: "allow_replace_Without_bill",
        label: "allow-replace-without-invoice",
        visible: false,
    },
    {
        name: "IS_Delete",
        label: "allow-delete-quotation-after-posting",
        visible: true,
    },
    {
        name: "IS_Update",
        label: "allow-edit-quotation-after-posting",
        visible: true,
    },
    {
        name: "register_customer_no_account",
        label: "allow-customer-without-account",
        visible: false,
    },
    {
        name: "allow_discount",
        label: "allow-discount",
        visible: true
    },
    {
        name: "PrintAfter_Save",
        label: "print-invoice-after-save",
        visible: true,
    },
    {
        name: "NoRepeatItem",
        label: "perm-cancel-item-grouping",
        visible: true,
    },

    {
        name: "use_barcode_reader",
        label: "use-barcode-reader",
        visible: true,
    },
];
export const permOrder = [
    { name: "Automatic_Insert", label: "perm-automatic-entry", visible: true },

    {
        name: "UpdatePurchDate",
        label: "perm-allow-edit-purchase-order-date",
        visible: true,
    },
    {
        name: "UpdatePurchPrice",
        label: "allow-edit-purchase-price",
        visible: true,
    },
    {
        name: "purchVatUpdate",
        label: "perm-allow-edit-tax-on-purchase-order",
        visible: true,
    },
    {
        name: "IS_Delete",
        label: "perm-allow-delete-posted-purchase-order",
        visible: true,
    },
    {
        name: "IS_Update",
        label: "perm-allow-edit-posted-purchase-order",
        visible: true,
    },
    {
        name: "use_price_without_vat",
        label: "use-price-excluding-tax-purchase-order",
        visible: true,
    },
    {
        name: "Purch_than_Less_Purch_Item",
        label: "perm-allow-price-below-item-purchase",
        visible: true,
    },

    {
        name: "Cust_PurchPrice",
        label: "perm-last-purchase-price-per-supplier",
        visible: false,
    },
    {
        name: "Hide_Purch_Bill_Price",
        label: "perm-hide-sale-price",
        visible: true,
    },
    {
        name: "Purch_out_goods",
        label: "print-goods-exit-permit-purchase-return",
        visible: false,
    },

    {
        name: "allow_discount",
        label: "allow-discount",
        visible: true
    },
    {
        name: "inv_post_unlock",
        label: "perm-allow-edit-delete-posted-invoice",
        visible: false,
    },
    {
        name: "NoRepeatItem",
        label: "perm-cancel-item-grouping",
        visible: true,
    },
    {
        name: "use_barcode_reader",
        label: "use-barcode-reader",
        visible: true,
    },
];

export const permSafes = [
    { name: "Automatic_Insert", label: "perm-automatic-entry", visible: true },

    {
        name: "UpdatePurchDate",
        label: "perm-allow-edit-opening-stock-date",
        visible: true,
    },
    {
        name: "UpdatePurchPrice",
        label: "perm-allow-edit-opening-stock-price",
        visible: true,
    },
    {
        name: "purchVatUpdate",
        label: "perm-allow-edit-tax",
        visible: true,
    },
    {
        name: "IS_Delete",
        label: "perm-allow-delete-opening-stock",
        visible: true,
    },
    {
        name: "IS_Update",
        label: "perm-allow-stock-correction",
        visible: true,
    },
    {
        name: "use_price_without_vat",
        label: "use-price-excluding-tax-purchase-order",
        visible: false,
    },
    {
        name: "Purch_than_Less_Purch_Item",
        label: "perm-allow-price-below-item-purchase",
        visible: false,
    },

    {
        name: "Cust_PurchPrice",
        label: "perm-last-purchase-price-per-supplier",
        visible: false,
    },
    {
        name: "Hide_Purch_Bill_Price",
        label: "perm-hide-sale-price",
        visible: false,
    },
    {
        name: "Purch_out_goods",
        label: "print-goods-exit-permit-purchase-return",
        visible: false,
    },

    {
        name: "allow_discount",
        label: "allow-discount",
        visible: true,
    },
    {
        name: "inv_post_unlock",
        label: "perm-allow-edit-delete-posted-invoice",
        visible: false,
    },
    {
        name: "NoRepeatItem",
        label: "perm-cancel-item-grouping",
        visible: true,
    },
    {
        name: "use_barcode_reader",
        label: "use-barcode-reader",
        visible: true,
    },
];

export const permOtherSafes = (id) => [

    {
        name: "UpdatePurchDate",
        label: "perm-allow-edit-date",
        visible: true,
    }, {
        name: "SaleInMinus",
        label: id == 2 ? "السماح بالصرف بدون كمية بالمحزون" : "السماح بالتحويل بدول كمية بالمخزون",
        visible: [2, 3].includes(id) ? true : false,
    },
    {
        name: "UpdatePurchPrice",
        label: "perm-allow-edit-price",
        visible: true,
    },
    {
        name: "IS_Delete",
        label: "perm-allow-delete-after-entry",
        visible: true,
    },
    {
        name: "IS_Update",
        label: "perm-allow-stock-correction",
        visible: true,
    },

    {
        name: "inv_post_unlock",
        label: "perm-allow-edit-delete-posting",
        visible: false,
    },
];


export const permOtherSales = [
    ,
    {
        name: "cancel_payed_network",
        label: "perm-disable-network-payment",
        visible: true,
    },
    {
        name: "cancel_payed_bank",
        label: "perm-disable-bank-transfer",
        visible: true,
    }, {
        name: "cancel_bill_agel",
        label: "perm-disable-credit-payment",
        visible: true,
    },
    , {
        name: "cancel_payed_emp",
        label: "perm-disable-employee-payment",
        visible: true,
    },
    {
        name: "Re_Discount",
        label: "perm-refundable-discount",
        visible: true,
    },
    {
        name: "Re_Discount_agel",
        label: "perm-credit-refundable-discount",
        visible: true,
    },
    {
        name: "btnDisCode",
        label: "use Discount Code",
        visible: true,
    },
];

export const permOthers = [
    {
        name: "is_tab3_sub",
        label: "tobacco-tax-enabled",
        visible: true,
    },
    {
        name: "use_lock_date",
        label: "perm-enable-tax-period-closing",
        visible: true,
    },
];

export const permOtherAccount = [
    {
        name: "UpdateSaleDate",
        label: "perm-allow-edit-document-date",
        visible: true,
    },
    {
        name: "IS_Delete",
        label: "perm-allow-delete-saved-document",
        visible: true,
    },
    {
        name: "IS_Update",
        label: "perm-allow-edit-saved-document",
        visible: true,
    },
    {
        name: "show_cust_balance",
        label: "perm-show-account-balance-on-print",
        visible: true,
    },
];

export const select_Types = [
    { Form_id: 40002, id: 1, name: "المبيعات" },
    { Form_id: 40001, id: 3, name: "المشتريات" },
    { Form_id: 10004, id: 4, name: "البيانات الأساسية" },
    { Form_id: 40014, id: 5, name: "عرض السعر" },
    { Form_id: 40025, id: 6, name: "أمر الشراء" },
    { Form_id: 40005, id: 7, name: "المخازن" },
    { Form_id: 50001, id: 8, name: "الحسابات" },
    { Form_id: 1000, id: 9, name: "الحسابات الوسيطة" },
    { Form_id: 40005, id: 10, name: "اعدادات اخرى" },
];





